import { NgModule } from '@angular/core';
import { ALL_QUEUES_COMPONENTS } from '.';
import { CommonModule } from '@angular/common';
import { AllQueuesRoutingModule } from './all-queues-routing';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { ToastService, UikitBreadcrumbComponent } from '@hss-m/uikit-common';
import { FiltersModule } from 'src/app/shared/modules/filters/filters.module';
import { DataViewTableModule } from 'src/app/shared/modules/data-view-table/data-view-table.module';

@NgModule({
  declarations: ALL_QUEUES_COMPONENTS,
  imports: [
    CommonModule,
    SharedModule,
    AllQueuesRoutingModule,
    DataViewTableModule,
    FiltersModule,
    UikitBreadcrumbComponent,
  ],
  providers: [ ToastService ]
})
export class AllQueuesModule { }
